import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
  return /*#__PURE__*/_jsx("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    children: props.children
  });
};
export default FilterDropdownMenuWrapper;